export default "/fonts/bauhs93-webfont.woff?5d6a7e179b9f0c59074efac57ac4abb2";